import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSyncProblem = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M4 26.6667V24H7.66667L7.13333 23.5334C5.97778 22.5112 5.16667 21.3445 4.7 20.0334C4.23333 18.7223 4 17.4 4 16.0667C4 13.6 4.73889 11.4056 6.21667 9.48337C7.69444 7.56115 9.62222 6.28893 12 5.66671V8.46671C10.4 9.04449 9.11111 10.0278 8.13333 11.4167C7.15556 12.8056 6.66667 14.3556 6.66667 16.0667C6.66667 17.0667 6.85556 18.0389 7.23333 18.9834C7.61111 19.9278 8.2 20.8 9 21.6L9.33333 21.9334V18.6667H12V26.6667H4ZM16 22.6667C15.6222 22.6667 15.3056 22.5389 15.05 22.2834C14.7944 22.0278 14.6667 21.7112 14.6667 21.3334C14.6667 20.9556 14.7944 20.6389 15.05 20.3834C15.3056 20.1278 15.6222 20 16 20C16.3778 20 16.6944 20.1278 16.95 20.3834C17.2056 20.6389 17.3333 20.9556 17.3333 21.3334C17.3333 21.7112 17.2056 22.0278 16.95 22.2834C16.6944 22.5389 16.3778 22.6667 16 22.6667ZM14.6667 17.3334V9.33337H17.3333V17.3334H14.6667ZM20 26.3334V23.5334C21.6 22.9556 22.8889 21.9723 23.8667 20.5834C24.8444 19.1945 25.3333 17.6445 25.3333 15.9334C25.3333 14.9334 25.1444 13.9612 24.7667 13.0167C24.3889 12.0723 23.8 11.2 23 10.4L22.6667 10.0667V13.3334H20V5.33337H28V8.00004H24.3333L24.8667 8.46671C25.9556 9.5556 26.75 10.7389 27.25 12.0167C27.75 13.2945 28 14.6 28 15.9334C28 18.4 27.2611 20.5945 25.7833 22.5167C24.3056 24.4389 22.3778 25.7112 20 26.3334Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgSyncProblem);
export default ForwardRef;
